export enum ToastrMessageEnum {
  ChangeStatus = 'Change status',
  UpdateOwnStatusWarning = 'You cannot change your own status',

  DeleteAccount = 'Delete account',
  DeleteAccountWarning = 'Are you sure you want to delete user account of',
  DeleteOwnAccountWarning = 'Deleting your own account is not allowed',
  DeleteUserPlaylistsWarning = 'The following playlists created by this user will be stopped and deleted as well:',

  SuccessfullyCreatedTitle = 'successfully created',
  SuccessfullyDuplicatedTitle = 'successfully duplicated',
  SuccessfullyUpdatedTitle = 'successfully updated',
  SuccessfullyDeletedTitle = 'successfully deleted',
  SuccessfullyAssignedToTitle = 'was successfully assigned to',
  AssignmentSuccessfulTitle = 'Assignment successful',
  UnassignedSuccessfulTitle = 'Unassigned successful',
  AssignmentUnsuccessfulTitle = 'Assignment unsuccessful',

  PermissionDeniedMessage = 'You don’t have permission to view this specific screen. Please contact the system administrator',
  PermissionDeniedTitle = 'Permission denied',
  UnavailableScreenError = 'Screen is unavailable',

  ErrorOccuredTitle = 'An error occured',
  SomeErrorOccuredTitle = 'Some error ocurred!',
  UnauthorizedTitle = 'Unauthorized',
  ForbiddenTitle = 'Forbidden',
  RejectedTitle = 'Rejected',
  MethodNotAllowedTitle = 'Method not allowed',
  AccessToTheResourseIsNotAvailableTitle = 'Access to the target resource is no longer available',
  CheckYourConnectionWithServer = 'Check your connection with server',
  FailedToUploadTitle = 'Failed to upload',
  FileTypeNotSupported = 'File type is not supported. Please select another file.',

  ProfileUpdateTitle = 'Profile update',
  TwoFactorAuthEnabledMessage = `Two-factor authentication was successfully enabled`,
  TwoFactorAuthDisabledMessage = `Two-factor authentication was successfully disabled`,
  TwoFactorAuthDisablingMessage = `Are you sure you want to disable two-factor authentication?`,

  ApiTokenRevocationMessage = 'Token was successfully revoked',
  ApiTokenMessage = 'User API Token',

  PlaylistItemMinDurationInfoMessage = 'The time spent on item should be at least 1 second.',
}
